import React from "react";
import { string } from "prop-types";
import { Link } from "@quintype/components";
import { flatten } from "lodash";

import { MICROSITES_OLD_URLS } from "../../../../server/helpers/constants";

import RightArrow from "../icons/right-arrow";

import "./collection-title-with-arrow.m.css";

const CollectionTitleWithArrow = ({ collectionSlug, collectionName }) => {
  const genCollectionSlug = () => {
    const flattenedUrls = flatten(MICROSITES_OLD_URLS);
    const slugIndex = flattenedUrls.indexOf(collectionSlug);
    return slugIndex >= 0 ? flattenedUrls[slugIndex + 1] : collectionSlug;
  };

  return (
    <Link aria-label={collectionName} href={genCollectionSlug()}>
      <h2 styleName="headline" className="collection-title">
        <span className="headline-color" styleName="headline-text">
          {collectionName}
        </span>
        <RightArrow arrowColor="#d60000" />
      </h2>
    </Link>
  );
};

CollectionTitleWithArrow.propTypes = {
  collectionName: string,
  collectionSlug: string,
};

export default CollectionTitleWithArrow;
